<template>
    <div>
      <v-text-field
          v-model="calculationName"
          :label="languageData.calculations.nameLabel || 'Name'"
          :rules="nameRules"
          required
          class="mb-4"
      ></v-text-field>
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>
              <strong>{{ snackbar.title }}</strong>
            </div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
      <v-form ref="formCalculation" v-if="languageData.calculations">
        <v-progress-circular v-if="dataGetCalculationFetching"
                             indeterminate
                             color="primary"
        ></v-progress-circular>
          <Instance
            v-for="(child, index) in parents.children"
            v-model="parents.children[index]"
            :key="parents.children[index].id"
            :ref="parents.children[index].id"
            :level="0"
        >
        </Instance>          
      </v-form>
      <v-row justify="end">
          <v-btn
            color="primary"
            outlined
            class="mr-4 mt-4"
            @click="addCategoryEvent">
          {{ languageData.calculations.addCategoryLabel}}
        </v-btn>
        <v-btn
            color="primary"
            class="mt-4 mr-3"
            :loading="isSaving"
            @click="saveCalculationEvent">
        {{ languageData.calculations.saveCalculationLabel }}
        </v-btn>
      </v-row> 
      <ModalInfo
          :typeInfo="modalInfo.typeInfo"
          :headModal="modalInfo.head"
          :btn-dis-agree-text="languageData.btnDisAgreeText"
          :btnAgreeText="languageData.btnAgreeText"
          @clicked="hideModalSuccess"
          :show-modal="modalInfo.isShow"
          :text-modal="modalInfo.text">
      </ModalInfo>
    </div>
</template>

<script type="text/javascript">
import { Child } from "../../helpers/child";
import Instance from "../Instance/Instance.vue";
import { mapActions, mapState } from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo.vue";

export default {
  name: "CalculationForm",
  props: {
    data: {
      default: null,
      type: Array,
    },
    layout: String,
    calculation: Object
  },
  components: {
    Instance,
    ModalInfo
  },
  data() {
    return {
      calculationName: "",
      nameRules: [
        v => !!v || (this.languageData.calculations && this.languageData.calculations.nameRequired) || 'Name is required'
      ],
      parents: {children: []},
      lowestLevel: 0,
      itemsDeleted: [],
      categoriesDeleted: [],
      parentsDeleted: [],
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
    }
  },
  computed: {
    ...mapState("saveCalculation", {
      isSaving: state => state.isSaving,
      modalInfo: state => state.modalInfo
    }),
    ...mapState("getCalculation", {
      dataGetCalculationFetching: state => state.dataGetCalculationFetching,
    }),
  },
  methods: {
    ...mapActions("saveCalculation", ["storeCalculationRequest", "hideModal"]),
    ...mapActions("getCalculation", ["getCalculationRequest"]),
    ...mapActions("getCalculations", ["getCalculationDriveCostsHeadersTableRequest", "getCalculationMaterialCostsHeadersTableRequest", "getCalculationWorkCostsHeadersTableRequest"]),

    addCategoryEvent() {
        eventBus.$emit('addCategory');
    },

    saveCalculationEvent() {
        eventBus.$emit('saveCalculation');
    },

    saveCalculation: function() {
      this.$refs.formCalculation.validate();
      let subcategoryCheck = this.isEmpty(this.parents.children).length === 0;
      const calculationData = this.parents.children;
        if (this.$refs.formCalculation && this.$refs.formCalculation.validate() && subcategoryCheck) {
            const creds = {
                calculationName: this.calculationName,
                calculationData: calculationData,
                parentsDeleted: this.parentsDeleted,
                categoriesDeleted: this.categoriesDeleted,
                itemsDeleted: this.itemsDeleted,
            }
            if (this.layout === 'edit' && this.calculation.id) creds.calculationId = this.calculation.id;
            this.storeCalculationRequest({creds});
        } else {
            this.snackbar = {
            color: "error",
            icon: "error",
            mode: "multi-line",
            position: "top",
            corner: 'right',
            title: this.languageData.calculations.saveCalculationLabel,
            text: subcategoryCheck === false ? this.languageData.calculations.errorSaveCalculationSubcategory : this.languageData.calculations.errorSaveEstimation,
            visible: true
            };
        }
    },
    isEmpty(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.isEmpty(children) : children)
      return flattenArr.filter((e) => {
        return e.visibleInput === false && e.children.length === 0; // determine if estimation has visible inputs
      });
    },
    flattenArray(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.flattenArray(children) : children)

      return flattenArr.filter((e) => {
        return e.visibleInput === true;
      });
    },
    hideModalSuccess: function() {
      this.hideModal();
    },
    addCategory() {
      let newChild = new Child(null, false, 'category');
      this.parents.children.push(newChild);
      eventBus.$emit('categoryAdded', newChild.id);
    },
    addValues(data, num = 1) {
      const locale = 'en-US';
      const options = {minimumIntegerDigits: 2, useGrouping:false};
      let arr = data;
      for(let i = 0; i < arr.length; i++) {
        if(num === 1) {
          arr[i].number = (i + num).toLocaleString(locale, options);
        } else {
          if(arr[i].visibleInput) {
            arr[i].number = num + (i+1);
          } else {
            arr[i].number = num + (i+1).toLocaleString(locale, options);
          }
        }
        if(arr[i].children.length > 0) {
          this.addValues(arr[i].children, arr[i].number + '.');
        }
      }
    },
  },
  mounted() {
    if (this.layout === 'edit' && this.calculation) {
        this.parents.children = this.calculation.calculationData;
        this.calculationName = this.calculation.name || "";
    }
    this.getCalculationDriveCostsHeadersTableRequest();
    this.getCalculationMaterialCostsHeadersTableRequest();
    this.getCalculationWorkCostsHeadersTableRequest();

    if(this.parents.children.length === 0 && this.layout !== 'edit') {
      this.parents.children.push(new Child(null, false, 'category'));
      this.addValues(this.parents.children);
    }
    eventBus.$on("getCalculationSuccess", (categories) => {
      if(categories.length === 0) {
        eventBus.$emit('refreshCalculationNumbers');
      } else {
        this.parents.children = categories;
      }
      eventBus.$emit('assignVatEstimate');
    });

    eventBus.$on("deleteParent", (parent) => {
      this.parentsDeleted.push(parent.id);
      this.parents.children.splice(this.parents.children.indexOf(parent), 1)
    });
    eventBus.$on('deleteItem', (itemId) => {
      this.itemsDeleted.push(itemId);
    });
    eventBus.$on('deleteCategory', (categoryId) => {
      this.categoriesDeleted.push(categoryId);
    })
    eventBus.$on('addCategory', () => {
      this.addCategory();
      this.addValues(this.parents.children);
    });
    eventBus.$on('saveCalculation', () => {
      this.saveCalculation();
      this.addValues(this.parents.children);
      this.parentsDeleted = [];
      this.categoryDeleted = [];
      this.itemsDeleted = [];
    });

    eventBus.$on('refreshCalculationNumbers', () => {
      this.addValues(this.parents.children);
    });

    eventBus.$on('categoryAdded', (id) => {
      this.$nextTick(() => {
        this.$refs[id][0].$el.scrollIntoView({behavior: 'smooth'});
      })
    });

    eventBus.$on('updateNumbers', () => {
      this.addValues(this.parents.children)
    });
  },
  beforeDestroy() {
    eventBus.$off('addCategory');
    eventBus.$off('categoryAdded');
    eventBus.$off('deleteCategory');
    eventBus.$off('deleteParent');
    eventBus.$off('deleteItem');
    eventBus.$off('saveCalculation');
  }

}
</script>